import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RESTServiceV2 } from './rest.service.v2';

@Injectable({
  providedIn: 'root',
})
export class OnboardingService {
  constructor(private rest: RESTServiceV2) {}

  getOnboarding(userId?: string): Observable<any> {
    const resource = userId
      ? `/onboarding/${encodeURIComponent(userId)}`
      : '/onboarding';
    return this.rest.get(resource);
  }

  selectSignDocuments(userId: string, documents: string[]): Observable<any> {
    const resource = `/onboarding/${userId}`;
    return this.rest.post(resource, documents);
  }
}
